export default {
	productIds: ['com.jdsoftwarellc.ginrummy.removeads', 'com.jdsoftwarellc.ginrummy.fullversion']
};
